export default __webpack_public_path__ + "static/media/cassandra.fa4d6d7404e27268bbc813027becc386.svg";